// ============================================================================
// This file is RCOG 2027 PROJECT SPECIFIC
// ============================================================================

// Registration Member Types
const initMemberTypes = () => {
  const countrySelect = document.getElementById("user_country");
  const memberTypeSelect = document.getElementById("user_member_type_id");
  const subMemberTypeWrapper = document.getElementById("sub-member-type-wrapper");
  const subMemberTypeSelect = document.getElementById("user_sub_member_type_id");

  if (!countrySelect || !memberTypeSelect) return;

  // Skip initialization if member type field is disabled (editing mode)
  if (memberTypeSelect.disabled) return;

  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || "{}");
  const subMemberTypesByMemberType = JSON.parse(
    subMemberTypeSelect?.dataset.subMemberTypesByMemberType || "{}",
  );
  let initialMemberTypeId = memberTypeSelect.dataset.selectedMemberTypeId || "";
  let initialSubMemberTypeId =
    subMemberTypeSelect?.dataset.selectedSubMemberTypeId || "";

  function updateSubMemberTypeOptions() {
    if (!subMemberTypeSelect) return;

    const selectedMemberTypeId = memberTypeSelect.value;
    const subMemberTypes = subMemberTypesByMemberType[selectedMemberTypeId] || [];
    const preferredSubMemberTypeId =
      subMemberTypeSelect.value || initialSubMemberTypeId;

    subMemberTypeSelect.innerHTML = '<option value="">- Select -</option>';

    subMemberTypes.forEach(({ id, name }) => {
      const option = document.createElement("option");
      option.value = id;
      option.textContent = name;
      subMemberTypeSelect.appendChild(option);
    });

    if (
      preferredSubMemberTypeId &&
      subMemberTypes.some(({ id }) => id === preferredSubMemberTypeId)
    ) {
      subMemberTypeSelect.value = preferredSubMemberTypeId;
    }

    initialSubMemberTypeId = "";
  }

  function updateSubMemberTypeVisibility() {
    if (!subMemberTypeWrapper || !subMemberTypeSelect) return;

    updateSubMemberTypeOptions();

    const shouldShow = subMemberTypeSelect.options.length > 1;

    subMemberTypeWrapper.classList.toggle("hidden", !shouldShow);
    subMemberTypeSelect.disabled = !shouldShow;
    subMemberTypeSelect.required = shouldShow;

    if (!shouldShow) {
      subMemberTypeSelect.value = "";
    }
  }

  function updateMemberTypeOptions() {
    const selectedCountryCode = countrySelect.value;
    const preferredMemberTypeId = memberTypeSelect.value || initialMemberTypeId;

    // Clear existing options
    memberTypeSelect.innerHTML = '<option value="">- Select -</option>';

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true;
      return;
    }

    // Filter member types based on country rules
    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData;
      let shouldShow = false;

      switch (country_rule) {
        case "all_countries":
          shouldShow = true;
          break;
        case "specific_countries":
          shouldShow = countries.includes(selectedCountryCode);
          break;
        case "exclude_countries":
          shouldShow = !countries.includes(selectedCountryCode);
          break;
      }

      if (shouldShow) {
        const option = document.createElement("option");
        option.value = id;
        option.textContent = memberTypeName;
        memberTypeSelect.appendChild(option);
      }
    });

    if (
      preferredMemberTypeId &&
      Array.from(memberTypeSelect.options).some(
        (option) => option.value === preferredMemberTypeId,
      )
    ) {
      memberTypeSelect.value = preferredMemberTypeId;
    }

    initialMemberTypeId = "";
    memberTypeSelect.disabled = memberTypeSelect.options.length <= 1;
    updateSubMemberTypeVisibility();
  }

  countrySelect.addEventListener("change", updateMemberTypeOptions);
  memberTypeSelect.addEventListener("change", updateSubMemberTypeVisibility);

  // Initialize on page load
  updateMemberTypeOptions();
};

// Initialize all custom functionality
const initRcog2027Registration = () => {
  initMemberTypes();
};

export default initRcog2027Registration;
